import React from 'react'
import { Link } from 'react-router-dom'
import HelpCircle from '../../icons/help_circle.svg'

const HelpPopup: React.FunctionComponent = () => {
  return (
    <Link
      to="/docs"
      className="clear-button link menu_toggle"
      aria-label="Help"
      title="Help and Resources"
    >
      <HelpCircle />
    </Link>
  )
}

export default HelpPopup
